import './App.css'
import '@pandacss/styles.css'
import {BrowserRouter} from "react-router";
import Index from "./pages";

function App() {
    return (
        <BrowserRouter>
            <Index />
        </BrowserRouter>
    )
}

export default App;
